var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFtpLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296.58 67.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ftp_loader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.65,49.75H141.88v-26l-14,20.63c-5.36,7.91-10.89,8.08-16.37.32-4.5-6.38-8.77-12.92-13.71-20.24V49.73H83.73V12.39c0-9.17,6-13.3,14.47-9.33,2.93,1.37,5.48,4.25,7.34,7,4.54,6.76,8.56,13.86,12.81,20.81a16.47,16.47,0,0,0,1.48,1.62c5-8.06,9.88-15.86,14.61-23.78,3.21-5.38,7.94-7.35,13.9-6.66,4,.47,7.2,2.34,7.25,6.8C155.74,22.34,155.65,35.81,155.65,49.75Z",
    transform: "translate(0 -1.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.43,32H176c-.1,1.73-.18,3.11-.28,5.05h39.75V50H202.66c-10.49,0-21,0-31.46,0-6.33,0-9.42-3.16-9.46-9.53,0-9.82-.06-19.65,0-29.47,0-5.1,2.92-8.8,7.54-8.86C184.57,1.92,199.85,2,215.41,2v12.7H176L175.67,20h39.76Z",
    transform: "translate(0 -1.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.48,36.07a33.86,33.86,0,0,0-3.09,3.62c-5.83,9.51-14.21,12.68-25.5,9.51l19.89-23.15q-9.87-11.51-19.87-23.16C235.27-1.46,243.53,4.94,250,16.47c2.83-3.13,5.42-5.42,7.28-8.19C260.72,3.2,265.1,1.07,271.17,2c2.54.37,5.18.06,8.82.06L259.24,26C271.52,40.16,283.66,54.11,296.58,69c-6,0-10.74.17-15.48-.11-1.22-.07-2.58-1.32-3.5-2.36-7.78-8.68-15.46-17.43-23.19-26.15C253.22,39,252,37.68,250.48,36.07Z",
    transform: "translate(0 -1.52)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.93,14.87H0V2.37H57.4V14.73H35.79v35H21.93Z",
    transform: "translate(0 -1.52)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.93,49.7V2.39H77.36V49.7Z",
    transform: "translate(0 -1.52)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtpLoader);
export default __webpack_public_path__ + "static/media/ftp_loader.8f080448e67068caad1b6876bc6939c7.svg";
export { ForwardRef as ReactComponent };